import { useRef, useState } from "react";
import { CustomButton } from "../CustomButton";
import { ModalComponentV1 } from "../ModalComponentV1";
import YoutubeLogo from "assets/svg/YoutubeLogo.svg";
import styles from "./index.module.css";

type Props = {
  videoLink: string;
};

export const CustomVideoBtn = ({ videoLink }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const getEmbedBaseUrl = (url: string) => {
    try {
      const urlObj = new URL(url);
      let videoId = "";

      if (urlObj.hostname.includes("youtube.com") || urlObj.hostname.includes("youtu.be")) {
        if (urlObj.hostname.includes("youtu.be")) {
          videoId = urlObj.pathname.slice(1);
        } else {
          videoId = urlObj.searchParams.get("v") || "";
        }
      }

      if (!videoId) return "";

      return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
    } catch {
      return "";
    }
  };

  const baseEmbedUrl = getEmbedBaseUrl(videoLink);

  const playerSrc = baseEmbedUrl ? `${baseEmbedUrl}&autoplay=1` : "";

  const onOpen = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    if (iframeRef.current) {
      iframeRef.current.src = "";

      setTimeout(() => {
        if (iframeRef.current && baseEmbedUrl) {
          iframeRef.current.src = baseEmbedUrl;
        }
      }, 100);
    }

    setIsOpen(false);
  };

  return (
    <div className={styles.wrapper}>
      <CustomButton sizeButton="large" typeButton="tertiary" className={styles.btn} onClick={onOpen}>
        <div className={styles.btn}>
          <img src={YoutubeLogo} alt="youtube logo" />
          <div>Watch Video-review</div>
        </div>
      </CustomButton>

      <ModalComponentV1 isOpen={isOpen} onClose={onClose} title="Video-review" className={styles.modalVideo}>
        {baseEmbedUrl && isOpen ? (
          <div
            style={{
              position: "relative",
              width: "100%",
              height: 0,
              paddingBottom: "56.25%",
              background: "#000",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <iframe
              ref={iframeRef}
              src={playerSrc}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        ) : baseEmbedUrl ? null : (
          isOpen && <div style={{ color: "white", textAlign: "center", padding: "2rem" }}>Invalid Video Link</div>
        )}
      </ModalComponentV1>
    </div>
  );
};
